import { SET_CAT_ID, BEFORE_MODAL_MENU } from '../../redux/types';

const initialState = {
    catId: null,
    catAuth: false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CAT_ID:
            return {
                ...state,
                catId: action.payload,
                catAuth: true
            }
        case BEFORE_MODAL_MENU:
            return {
                ...state,
                catId: null,
                catAuth: false
            }
        default:
            return {
                ...state
            }
    }
}